module.exports = __webpack_public_path__ + "img/Lime-24-Blog-Banner6.d94079c6.jpg";